import {
  LIST_REPORT6,
  LIST_REPORT6_SUCCESS,
  LIST_REPORT6_CLEAN,
  LIST_REPORT6_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const Report6List = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORT6:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORT6_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORT6_CLEAN:
      state = initialState
      break
    case LIST_REPORT6_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Report6List
